import type { CSSProperties, PropsWithChildren } from 'react';

import { themeStyle, useNewThemeActive } from '@src/theming';
import type { DefaultTheme } from 'styled-components';

import { SpinnerWrapperContainer } from './styles';

const SpinnerWrapper: React.FC<
  PropsWithChildren<{ theme: DefaultTheme; style?: CSSProperties }>
> = ({ children, theme, style }) => {
  const isNewThemeActive = useNewThemeActive();

  const _theme = isNewThemeActive
    ? { ...theme, spinnerColor: themeStyle.varBlueMain }
    : theme;

  return (
    <SpinnerWrapperContainer style={style} theme={_theme}>
      {children}
    </SpinnerWrapperContainer>
  );
};

export default SpinnerWrapper;
